var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "mb-10",
    attrs: {
      "id": "daily-pattern-chart"
    }
  }), _c('div', {
    staticClass: "text-center text-default"
  }, [_vm._v("Load profile")])]);
}]

export { render, staticRenderFns }